module.exports = __webpack_public_path__ + "static/media/AW_rootbeer_hero_mobile_en.454b986a.jpg";